import React,{useEffect, useState} from 'react'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { AceptarTerminos } from '../../terminosCondiciones/AceptarTerminos';
import { SolicitudEmpresarialTyC } from '../../terminosCondiciones/SolicitudEmpresarialTyC';
import  ToHomeFromAdelantar  from '../../../components/misc/Redirect/ToHomeFromAdelantar';
import { ISolicitudEmpresarial } from '../../../interfaces/ISolicitudEmpresarial'
import { ITyCRequest } from '../../../interfaces/ITyCRequest';
import tarjetaEmpresarial from '../../../images/TarjetaEmpresarial.png'
import {  obtenerTyC } from '../services/terminosyCondiciones.service';
import { SUCCESS_ACEPTAR_TyC, SUCCESS_OBTENER_TyC } from '../utilities/constants';
import { aceptarTyC2 } from '../../shared/services/terminosycondiciones.service';

interface IState {
    step: number,
    SolicitudEmpresarial: ISolicitudEmpresarial,
    loadingTyC: boolean;
    redirect: boolean,
    url: string,
    tycVisible: boolean,
    invalido: boolean
}

interface IProps {
    solicitaEmpresarial: Function,
    canceloEmpresarial: Function
}
let solEmp: ISolicitudEmpresarial = {
    RazonSocial: "",
    CUIT: "",
    Email: "",
    Telefono: "",
    Ciudad: "",
    Provincia: "",
    Direccion: "",
    Id: 0,
    Estado: 0,
    Usuario: "",
    FechaAlta: "",
    Cliente: 0,
    SubCuenta: 0,
    Empresarial: "",
    FechaAltaStr:""

}
const SolicitudEmpresarial = (props: IProps) => {
    const [state,setState] = useState({
        tycVisible: false, 
        loadingTyC: true,
        step: 1, 
        redirect: false, 
        url: "",
        SolicitudEmpresarial: solEmp,
        invalido: false
    })
    useEffect(()=>{
        tycVerify()

    },[])

    const onChangeRazonSocial = (e: any) => {
        var solEmp = state.SolicitudEmpresarial;
        solEmp.RazonSocial = e.target.value;
        setState({...state, SolicitudEmpresarial: solEmp });
    };
    
    const onChangeCuit = (e: any) => {
        var solEmp = state.SolicitudEmpresarial;
        solEmp.CUIT = e.target.value;
        setState({ ...state,SolicitudEmpresarial: solEmp });
    };
    
    const onChangeEmail = (e: any) => {
        var solEmp = state.SolicitudEmpresarial;
        solEmp.Email = e.target.value;
        setState({ ...state, SolicitudEmpresarial: solEmp });
    };
    
    const onChangeTelefono = (e: any) => {
        var solEmp = state.SolicitudEmpresarial;
        solEmp.Telefono = e.target.value;
        setState({ ...state,SolicitudEmpresarial: solEmp });
    };
    const onChangeDireccion = (e: any) => {
        var solEmp = state.SolicitudEmpresarial;
        solEmp.Direccion = e.target.value;
        setState({...state, SolicitudEmpresarial: solEmp });
    };
    const onChangeLocalidad = (e: any) => {
        var solEmp = state.SolicitudEmpresarial;
        solEmp.Ciudad = e.target.value;
        setState({...state, SolicitudEmpresarial: solEmp });
    };
    const onChangeProvincia = (e: any) => {
        var solEmp = state.SolicitudEmpresarial;
        solEmp.Provincia = e.target.value;
        setState({...state, SolicitudEmpresarial: solEmp });
    };
    
    const onClickSeguir = (e: any) => {
        setState({...state, step: 2 });
    }
    
    const onClickAceptar = (e: any) => {
        if (validar())
            props.solicitaEmpresarial({ "PedidoEmpresarial": state.SolicitudEmpresarial });
        else
            setState({ ...state,invalido: true });
    }
    
    const validar = () => {
        var paso = true;
        if (state.SolicitudEmpresarial.Ciudad.length <= 1)
            paso = false;
        if (state.SolicitudEmpresarial.CUIT.length <= 1)
            paso = false;
        if (state.SolicitudEmpresarial.Direccion.length <= 1)
            paso = false;
        if (state.SolicitudEmpresarial.Email.length <= 1)
            paso = false;
        if (state.SolicitudEmpresarial.Provincia.length <= 1)
            paso = false;
        if (state.SolicitudEmpresarial.RazonSocial.length <= 1)
            paso = false;
        if (state.SolicitudEmpresarial.Telefono.length <= 1)
            paso = false;
        return paso
    }

    const onClickCancelar = (e: any) => {
        props.canceloEmpresarial();
    }

    const tycVerify = async () => {
        let postData: ITyCRequest = {
            idTyC: 2,
        }
        const {data,status} = await obtenerTyC(postData)
        if(status === 200){
            setState({...state, tycVisible: !data.tyC, loadingTyC: false });
        }
    }
    
    const onAcceptar = async() => {
        let postData: ITyCRequest = {
            idTyC: 2,
        }
        let response = await aceptarTyC2(postData)
        if(response.status === 200){
            setState({ ...state, tycVisible: false });
        }
    }

    const onCancelar = async() => {
        onClickCancelar(null);
    }
    const onHide = () => {
        onCancelar();
    }

    const tyc = <SolicitudEmpresarialTyC />;
    if (state.redirect) {
        return <ToHomeFromAdelantar tyc={true} />
    }
    else if (state.step == 2 && state.tycVisible)
        return (<Dialog header="Terminos y Condiciones" style={{ width: '60vw' }} visible={state.tycVisible} onHide={onHide} blockScroll>
            <AceptarTerminos componente={tyc} onAcceptar={onAcceptar} onCancelar={onCancelar} />
        </Dialog>)
    if (state.step == 1)
        return (
            <div className="empresarial-popup">
                <div className="empresarial-popup-left-side">
                    <p><span className="edenred font-weight-bold">Empresarial Edenred</span> se puede usar en cualquier comercio de la <span className="font-weight-bold">Red Mastercard</span> en Argentina.</p>
                    <p><span className="font-weight-bold">¡A la mejor Tasa del Mercado!</span></p>
                    <p><span className="font-weight-bold">Sin costo</span> de emisión, ni mantenimiento.</p>
                    <p className="t3">Plazo de entrega de la tarjeta: 7 días.</p>
                    <div className="empresarial-popup-conditions">
                        {state.tycVisible ? <Button label="Términos y Condiciones" onClick={onClickSeguir} /> : null}
                    </div>
                    <div className="empresarial-popup-btn">
                        <Button label="Seguir" onClick={onClickSeguir} />
                    </div>
                </div>
                <div className="empresarial-popup-right-size">
                    <img src={tarjetaEmpresarial} alt="Responsive image" />
                </div>
            </div>
        )
    else
        return (
            <div className="empresarial-popup-form">
                <p>Complete por favor los siguientes datos:</p>
                <InputText id="RazonSocial" value={state.SolicitudEmpresarial.RazonSocial} onChange={onChangeRazonSocial} placeholder="Razón Social" />
                <InputText id="Cuit" value={state.SolicitudEmpresarial.CUIT} onChange={onChangeCuit} placeholder="CUIT" />
                <InputText id="Email" value={state.SolicitudEmpresarial.Email} onChange={onChangeEmail} placeholder="Correo electronico" />
                <InputText id="Telefono" value={state.SolicitudEmpresarial.Telefono} onChange={onChangeTelefono} placeholder="Teléfono" />
                <InputText id="Direccion" value={state.SolicitudEmpresarial.Direccion} onChange={onChangeDireccion} placeholder="Dirección" />
                <InputText id="Localidad" value={state.SolicitudEmpresarial.Ciudad} onChange={onChangeLocalidad} placeholder="Localidad" />
                <InputText id="Provincia" value={state.SolicitudEmpresarial.Provincia} onChange={onChangeProvincia} placeholder="Provincia" />
                <div className="empresarial-popup-form-btn d-flex mt-3">
                    <Button className="p-button-secondary mr-2" label="Salir" onClick={onClickCancelar} />
                    <Button className="ml-2" label="Solicitar" onClick={onClickAceptar} />
                </div>
                <div className="row">
                    {(state.invalido ? <p>Todos los campos son requeridos.</p> : null)}
                </div>
            </div>
        )
}

export default SolicitudEmpresarial
